module.exports = __webpack_public_path__ + "static/img/SK@3x.f7859dbb.jpg";